import React from "react";

interface EmailDeliverySectionProps {
  editing: boolean;
  scheduledSendAt: string;
  scheduleForLater: boolean;
  onScheduleForLaterChange: (value: boolean) => void;
  onChange: (value: string) => void;
  firstOfferedAppointment: string;
}

export default function EmailDeliverySection({ editing, scheduledSendAt, scheduleForLater, onScheduleForLaterChange, onChange, firstOfferedAppointment }: EmailDeliverySectionProps) {
  return (
    <>
      {!editing ? (
        <section className="app-surface p-4" aria-labelledby="scheduling-email-delivery-heading">
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <h2 id="scheduling-email-delivery-heading" className="text-lg font-semibold text-neutral-950 dark:text-white">Email delivery</h2>
            <p className="text-xs text-neutral-500 dark:text-neutral-400">Arizona time · MST (UTC−7)</p>
          </div>
          <fieldset className="mt-3 flex flex-wrap gap-x-6 gap-y-3">
            <legend className="sr-only">When to send the scheduling email</legend>
            <label className="flex cursor-pointer items-center gap-2 text-sm text-neutral-700 dark:text-neutral-200">
              <input type="radio" name="scheduling-email-delivery" checked={!scheduleForLater} onChange={() => onScheduleForLaterChange(false)} className="h-4 w-4 accent-emerald-600" />
              Send now
            </label>
            <label className="flex cursor-pointer items-center gap-2 text-sm text-neutral-700 dark:text-neutral-200">
              <input type="radio" name="scheduling-email-delivery" checked={scheduleForLater} onChange={() => onScheduleForLaterChange(true)} className="h-4 w-4 accent-emerald-600" />
              Schedule for later
            </label>
          </fieldset>
          {scheduleForLater ? (
            <div className="mt-4 grid items-end gap-3 sm:grid-cols-2">
              <div>
                <label htmlFor="scheduling-email-scheduled-send-at" className="text-sm font-medium text-neutral-700 dark:text-neutral-200">Send date and time (Arizona)</label>
                <input id="scheduling-email-scheduled-send-at" type="datetime-local" className="app-input" required value={scheduledSendAt} onChange={(event) => onChange(event.target.value)} aria-describedby="scheduling-email-delivery-help" />
              </div>
              <p id="scheduling-email-delivery-help" className="text-sm text-neutral-500 dark:text-neutral-400">The email will wait until this time to send. Choose a future time before the link expires and the {firstOfferedAppointment}.</p>
            </div>
          ) : null}
        </section>
      ) : scheduledSendAt ? (
        <p className="text-sm text-neutral-600 dark:text-neutral-300">Email delivery was scheduled for {scheduledSendAt.replace("T", " at ")} Arizona time.</p>
      ) : null}

    </>
  );
}
